import { render, staticRenderFns } from "./inactiveaccounts.vue?vue&type=template&id=21c40340"
import script from "./inactiveaccounts.vue?vue&type=script&lang=js"
export * from "./inactiveaccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports